import { render } from "./NftTypeFilterComp.vue?vue&type=template&id=2339d249&ts=true"
import script from "./NftTypeFilterComp.vue?vue&type=script&lang=ts"
export * from "./NftTypeFilterComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__